import React, { useContext, useState } from "react";
import ResetPasswordForm from "./ResetPasswordForm";
import Api from "../../utils/Api";
import { context } from "../../context/context";
import { Grid } from "@mui/material";
import SidePanel from "../Shared/SidePanel";
import { setNotification } from "../../utils/helpers";
export const ResetPassword = ({token}) => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { dispatch } = useContext(context);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await Api.addData('/api/v1/reset-pass', null, { password, token });
      setNotification(dispatch, {
        severity: "info",
        message: "Successfully Reset Password. Now you can login to your account with new password.",
        open: true,
        autoHideDuration: 4000,
      })
      setPassword("")
      setConfirmPassword("")
      
    } catch (err) {
        let errMessage = err.response?.data?.message;
      setNotification(dispatch, {
        severity: "error",
        message: errMessage,
        open: true,
        autoHideDuration: 4000,
      })
    }
  };
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={5} xl={5}>
        <ResetPasswordForm
          handleSubmit={submit}
          setPassword={setPassword}
          password={password}
          setConfirmPassword={setConfirmPassword}
          confirmPassword={confirmPassword}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={7} xl={7}>
        <SidePanel />
      </Grid>
    </Grid>
  );
};